export default {
  'homepage-hero': {
    // webm: require('../video/hero.webm'),
    mp4: require('../video/hero.mp4')
  }
}
